import ContentLoader from 'react-content-loader';
import { ContentLoadersProps } from './types';

export const WebinarListContentLoader = ({ loaderCount }: ContentLoadersProps) => (
    <>
        {loaderCount.map((data: any) => (
            <ContentLoader
                key={data}
                speed={2}
                width="100%"
                height={80}
                // viewBox="0 12 900 160"
                backgroundColor="#C0C0C0"
                foregroundColor="#ecebeb"
            >
                <rect x="70" y="25" width="178" height="16" />
                <rect x="70" y="45" width="178" height="20" />
                <rect x="1050" y="20" width="150" height="30" />
            </ContentLoader>
        ))}
    </>
);
